import { render, staticRenderFns } from "./CheckoutPaymentBankTransfer.vue?vue&type=template&id=30c79f06&scoped=true&"
import script from "./CheckoutPaymentBankTransfer.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c79f06",
  null
  
)

export default component.exports